import React, { useState } from 'react'
import '../styles/contactComponent.css'

export default function ContactMe(props) {
  const [inputs, setInputs] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  })

  const handleOnChange = event => {
    event.persist()
    setInputs(prev => ({
      ...prev,
      [event.target.id]: event.target.value,
    }))
  }



  return (
    <div className="contactDiv">
      <div className="contactTitle">
        <h1>{props.contact}</h1>
      </div>
      <form className="formContact"  action="https://formbold.com/s/oPavb" method="POST">
        <div className="fullname">
          <label htmlFor="name"> {props.name}</label>
          <input onChange={handleOnChange} value={inputs.name} id="name" type="name" name="name" placeholder={props.name} />
        </div>
        <div className="email">
          <label htmlFor="email"> {props.email}</label>
          <input onChange={handleOnChange} value={inputs.email} id="email" type="email" name="email" placeholder={props.example} />
        </div>
        <div className="subject">
          <label htmlFor="subject">{props.subject}</label>
          <input onChange={handleOnChange} value={inputs.subject} id="subject" type="text" name="subject" placeholder={props.subjecttype} />
        </div>
        <div className="message">
          <label htmlFor="message">{props.message}</label>
          <textarea onChange={handleOnChange} value={inputs.message} id="message" name="message" placeholder={props.messagetype} />
        </div>
        <div className="submit">
          <button type="submit">{props.submit}</button>
        </div>
      </form>
    </div>
  )
}
